import { CSSProperties, FC } from 'react';
import { useLanguage } from '@monorepo/hub-common';
import { Box } from '@monorepo/nova-ui';
import { HeaderMenuLink, LanguageOption } from '@monorepo/types';

type Props = {
  activeMenu: HeaderMenuLink | null;
  width?: CSSProperties['width'];
  height?: CSSProperties['height'];
};

export const MenuBanner: FC<Props> = ({ activeMenu, width, height }) => {
  const { resolvedLanguage } = useLanguage();

  const images = activeMenu?.meta?.images as Partial<
    Record<LanguageOption, string>
  >;
  const imageUrl = images?.[resolvedLanguage as LanguageOption] || images?.en;

  return (
    <Box
      width={width}
      height={height}
      maxWidth={422}
      maxHeight={307}
      sx={{ '& > img': { width: '100%' } }}
    >
      {imageUrl && (
        <img
          src={imageUrl}
          loading="lazy"
          alt={activeMenu?.label}
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      )}
    </Box>
  );
};
